module.exports = __webpack_public_path__ + "img/noticia1.cfcbcabc.jpg";